export default __webpack_public_path__ + "static/media/林澤.e4ca5473.jpg";